import { Typography } from "@mui/material"
import { useState } from "react"
import { removeProgram } from "../../api"
import Modal from "../ui/Modal"
import { useSnackbar } from "notistack"

const DeleteProgram = (props) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const deleteProgram = () => {
    setLoading(true)
    removeProgram(props.data?.id)
      .then(() => {
        enqueueSnackbar("Program Deleted", { variant: "success" })
        props.refresh()
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }
  return (
    <Modal
      {...props}
      title="Delete Program"
      actionText="Delete"
      loading={loading}
      action={deleteProgram}
    >
      <Typography>
        Do you want to delete program '{props.data?.name}'? <br /> All material
        will be deleted.
      </Typography>
    </Modal>
  )
}

export default DeleteProgram
